<template>
  <template v-if="step === 'cash'">
    <DrawerHeader @close="emit('back')">
      Cash Tendered
    </DrawerHeader>
    <div class="flex flex-1 flex-col px-6">
      <div class="mb-4 flex flex-1 flex-col px-8">
        <div
          class="flex flex-1 flex-col items-center justify-center"
        >
          <CustomAmountDisplay :value="cashTendered" />
        </div>
        <div class="flex items-center justify-between">
          <h3 class="text-xs text-background-fg/50">
            Remaining Due
          </h3>
          <p
            class="text-lg font-bold leading-tight text-background-fg/87"
          >
            {{
              formatToMerchantCurrencyString(remainingDue)
            }}
          </p>
        </div>
      </div>
      <BaseNumpad v-model="cashTendered" />
    </div>
    <div class="flex items-center justify-center p-4">
      <ActionButtonPrimary
        class="w-full"
        :disabled="cashTendered === 0"
        @click="onFinishCash"
      >
        Pay
        {{ formatToMerchantCurrencyString(cashTendered) }}
      </ActionButtonPrimary>
    </div>
  </template>
  <template v-else>
    <DrawerHeader @close="step = 'cash'">
      Change Given
    </DrawerHeader>
    <div class="flex flex-1 flex-col px-6">
      <div class="mb-4 flex flex-1 flex-col px-8">
        <div
          class="flex flex-1 flex-col items-center justify-center"
        >
          <CustomAmountDisplay :value="changeGiven" />
        </div>
        <div class="flex items-center justify-between">
          <!-- <StatRow label="CASH TENDERED" value="" -->
          <h3 class="text-xs text-background-fg/50">
            Change
          </h3>
          <p
            class="text-lg font-bold leading-tight text-background-fg/87"
          >
            {{
              formatToMerchantCurrencyString(changeGiven)
            }}
          </p>
        </div>
        <div class="flex items-center justify-between">
          <h3 class="text-xs text-background-fg/50">
            Amount Kept
          </h3>
          <p
            class="text-lg font-bold leading-tight text-background-fg/87"
          >
            {{
              formatToMerchantCurrencyString(
                cashTendered - changeGiven
              )
            }}
          </p>
        </div>
      </div>
      <BaseNumpad v-model="changeGiven" />
    </div>
    <div class="flex items-center justify-center p-4">
      <ActionButtonPrimary
        class="w-full"
        :disabled="changeSubmitDisabled"
        @click="onFinishChange"
      >
        <template v-if="changeGiven === 0">
          No change
        </template>
        <template v-else>
          Give
          {{ formatToMerchantCurrencyString(changeGiven) }}
          Change
        </template>
      </ActionButtonPrimary>
    </div>
  </template>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>

<script setup lang="ts">
const { formatToMerchantCurrencyString } = useCurrency()

const props = defineProps<{
  remainingDue: number
}>()
const emit = defineEmits<{
  (
    event: "submit",
    cashTendered: number,
    changeGiven: number
  ): void
  (event: "back"): void
}>()

const step = ref<"cash" | "change">("cash")

const cashTendered = ref(0)
const changeGiven = ref(0)

const changeSubmitDisabled = computed(
  () => cashTendered.value <= changeGiven.value
)

const onFinishCash = () => {
  step.value = "change"
}
const onFinishChange = () => {
  emit("submit", cashTendered.value, changeGiven.value)
}
</script>
